import 'dayjs/locale/pt-br';

import { Badge, Card, Col, Modal, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';

import AppLinkButton from '../../commons/buttons/AppLinkButton';
import AppLoading from '../../commons/AppLoading';
import ConfirmModal from '../../commons/modal/ConfirmModal';
import HallAppToast from '../../commons/HallAppToast';
import StockAPI from './StockAPI';
import dayjs from 'dayjs';
import { formatInReal } from '../../commons/util/HallAppUtil';

const stockAPI = new StockAPI();

function HistoryStockModal({ closeShow, show, product, callUpdate }) {
    const [isLoading, setIsLoading] = useState(true);
    const [history, setHistory] = useState([]);
    const [showModalDelete, setShowModalDelete] = useState(false)
    const [isLoadingModalDelete, setIsLoadingModalDelete] = useState(false)
    const [currentProduct, setCurrentProduct] = useState({})

    useEffect(() => {
        if (show) {
            getHistory();
        }
    }, [show]);

    const getHistory = async () => {
        try {
            const resp = await stockAPI.historyProduct(product.id);
            // Ordena do mais recente para o mais antigo
            const sorted = [...resp.data].sort((a, b) =>
                new Date(b.createDate).getTime() - new Date(a.createDate).getTime()
            );

            setHistory(sorted);
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoading(false);
        }
    };

    const formatDate = (date) => {
        return dayjs(date).locale('pt-br').format('DD/MM/YYYY HH:mm');
    };

    const getActionBadge = (action) => {
        const variant = action === 'INPUT' ? 'success' : 'danger';
        const label = action === 'INPUT' ? 'ENTRADA' : 'SAÍDA';
        return <Badge bg={variant}>{label}</Badge>;
    };


    const deleteProduct = async () => {
        try {
            setIsLoadingModalDelete(true)
            await stockAPI.deleteMovement(currentProduct?.id);
            HallAppToast.success();
            setCurrentProduct({})
            setShowModalDelete(false)
            getHistory()
            if (callUpdate) {
                callUpdate();
            }
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoadingModalDelete(false)
        }
    }


    return (
        <>
            <Modal show={show} fullscreen={true} onHide={() => closeShow()}>
                <Modal.Header className="custom-close-button" closeButton>
                    <Modal.Title style={{ textAlign: 'center', fontSize: '16px' }}>
                        HISTÓRICO DE MOVIMENTAÇÕES
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isLoading ? (
                        <AppLoading />
                    ) : history.length === 0 ? (
                        <p style={{ textAlign: 'center', marginTop: '20px' }}>
                            Nenhuma movimentação encontrada.
                        </p>
                    ) : (
                        <Row xs={1} md={2} className="g-3">
                            {history.map((item) => (
                                <Col key={item.id}>
                                    <Card
                                        className="shadow-sm border-0"
                                        style={{
                                            borderLeft:
                                                item.action === 'INPUT'
                                                    ? '6px solid #28a745'
                                                    : '6px solid #dc3545',
                                            borderRadius: '12px',
                                        }}
                                    >
                                        <Card.Body>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <h6 style={{ margin: 0 }}>{getActionBadge(item.action)}</h6>
                                                <small style={{ color: '#6c757d' }}>
                                                    {formatDate(item.createDate)}
                                                </small>
                                            </div>

                                            <p
                                                style={{
                                                    fontSize: '14px',
                                                    marginTop: '10px',
                                                    marginBottom: '5px',
                                                }}
                                            >
                                                <strong>Descrição:</strong>{' '}
                                                {item.description || 'Não informada'}
                                            </p>

                                            {item.destination && (
                                                <p style={{ fontSize: '14px', marginBottom: '5px' }}>
                                                    <strong>Destino:</strong> {item.destination === 'CONSUMPTION' ? 'Consumo' : 'Venda'}
                                                </p>
                                            )}

                                            <p style={{ fontSize: '14px', marginBottom: '5px' }}>
                                                <strong>Resp. Cadastro:</strong> {item.userResponsible}
                                            </p>

                                            <p style={{ fontSize: '14px', marginBottom: 0 }}>
                                                <strong>Quantidade:</strong>{' '}
                                                <span style={{ color: '#6c757d' }}>{item.oldQuantity}</span>{' '}
                                                →{' '}
                                                <span
                                                    style={{
                                                        color:
                                                            item.action === 'INPUT' ? '#28a745' : '#dc3545',
                                                        fontWeight: 'bold',
                                                    }}
                                                >
                                                    {item.newQuantity}
                                                </span>
                                            </p>

                                            

                                            {item.destination === 'SALE' &&
                                                <p style={{ fontSize: '14px', marginBottom: '5px' }}>
                                                    <strong>Comissão:</strong>{' '}
                                                    <span style={{ color: '#6c757d' }}>{item.percentageCommission}%</span>{' '}
                                                    →{' '}
                                                    <span
                                                        style={{
                                                            color: '#28a745',
                                                            fontWeight: 'bold',
                                                        }}
                                                    >
                                                        {formatInReal(item.commission)}
                                                    </span>
                                                </p>
                                            }


                                            {item.destination === 'SALE' &&
                                                <p style={{ fontSize: '14px', marginBottom: '5px' }}>
                                                    <strong>Resp. Venda:</strong>
                                                </p>
                                            }

                                            {
                                                item.employeeCommission?.map((em) => {
                                                    return <li>{em.employeeName} - {formatInReal(em.commission)}</li>
                                                })
                                            }

                                            <hr></hr>
                                            <AppLinkButton width='100%' name='cancelar' onClick={() => {
                                                setCurrentProduct(item)
                                                setShowModalDelete(true)
                                            }} />

                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    )}
                </Modal.Body>
            </Modal>

            {showModalDelete && <ConfirmModal show={showModalDelete}
                title='Cancelar'
                isLoading={isLoadingModalDelete}
                confirm={() => deleteProduct()}
                closeModal={() => {
                    setShowModalDelete(false)
                    setCurrentProduct({})
                }}
            >
                Deseja cancelar essa movimentação?
            </ConfirmModal>}
        </>
    );
}

export default HistoryStockModal;
